import { RegisteredWebSocketEndpoint } from '../websockets/websocketTypes';
import { ArrayFormat, TQueryParamValue } from './endpoint';
import { parseEndpoint } from './parseEndpoint';
import { RegisteredHttpEndpoint } from './types/httpTypes';

type Stringable = string | number | boolean;

export function buildUrl({
    endpoint,
    rootUrl,
    pathParams,
    queryParams,
    arrayFormat = 'comma',
}: {
    endpoint: RegisteredHttpEndpoint | RegisteredWebSocketEndpoint;
    rootUrl: string;
    pathParams: Record<string, Stringable>;
    queryParams: Record<string, TQueryParamValue>;
    arrayFormat?: ArrayFormat;
}): { method: string; url: string } {
    const { method, pathTemplate } = parseEndpoint(endpoint);

    let pathPart: string = pathTemplate;
    for (const [k, val] of Object.entries(pathParams)) {
        const toBeReplaced = `:${k}`;
        if (!pathPart.includes(toBeReplaced)) {
            throw new Error(
                `Cannot inject ${JSON.stringify(pathParams)} into path template "${pathTemplate}", ` +
                    `which does not contain "${toBeReplaced}" as a substring.`,
            );
        }
        pathPart = pathPart.replace(toBeReplaced, encodeURIComponent(val + ''));
    }

    const searchParams = new URLSearchParams();
    for (const [k, val] of Object.entries(queryParams)) {
        if (Array.isArray(val) && arrayFormat === 'repeat') {
            val.forEach((v) => searchParams.append(k, v + ''));
        } else {
            searchParams.set(k, val + '');
        }
    }
    const numberOfSearchParams = Array.from(searchParams.keys()).length;
    const searchPart = numberOfSearchParams === 0 ? '' : `?${searchParams.toString()}`;

    return {
        method: method,
        url: rootUrl + pathPart + searchPart,
    };
}
